module.exports = __webpack_public_path__ + "img/8dfe538.png";